export const GET_IMAGES_SUCCESS = 'GET_IMAGES_SUCCESS';
